import { render, staticRenderFns } from "./GroupData.vue?vue&type=template&id=67dbb32a"
import script from "./GroupData.vue?vue&type=script&lang=js"
export * from "./GroupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports